<div class="tw-flex tw-flex-col tw-items-center tw-mt-28">
  <p-progressSpinner styleClass="tw-w-16 tw-h-16"></p-progressSpinner>
  <div>{{ title }}</div>
</div>
